import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDocumentCreate(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M8 14C8 13.4477 8.44772 13 9 13H11V11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V13H15C15.5523 13 16 13.4477 16 14C16 14.5523 15.5523 15 15 15H13V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V15H9C8.44772 15 8 14.5523 8 14Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5858 2.58579C14.2107 2.21071 13.702 2 13.1716 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L14.5858 2.58579ZM18 9V20H6V4H13V8C13 8.55228 13.4477 9 14 9H18Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
